module.exports = __webpack_public_path__ + "static/ksiegowosc2-01-0c53b26bab79a846dc0b9eccb7dac552.png";